export default "__VITE_ASSET__DKeERE14__"